export default "__VITE_ASSET__7ac1da2d__"